// Ideally you should take these vars from process.env.REACT_APP_*
// and define them in e.g. .env.local (if you're using Create React App)

// Authorization screen base URL
// e.g. https://developer.github.com/apps/building-oauth-apps/authorizing-oauth-apps/#1-request-a-users-github-identity
export const authorizationUrl = 'https://login.microsoftonline.com/a8ee146e-0dcf-4435-8677-eb7f4cf3b5f5/oauth2/v2.0/authorize';

// To get a client ID, create an app, e.g.
// GitHub (authorization code grant only): https://github.com/settings/developers
// Spotify (implicit grant & auth code): https://developer.spotify.com/dashboard/applications
export const clientId = 'ee23066a-1088-43ca-b3e2-d2da7d5636a6';

// You get to configure this in your OAuth settings
// If you use React Router, the relative path (empty here) can match
// that of a route which displays nothing
export const redirectUri = 'https://master.dj5dq9npte6en.amplifyapp.com';

// Authorization code flow only: base URL for your server
// The one provided below is that of the sample Express server provided
export const serverUrl = 'https://master.dj5dq9npte6en.amplifyapp.com';

export const appServerUrl = "https://login.microsoftonline.com/a8ee146e-0dcf-4435-8677-eb7f4cf3b5f5";

export const oauthServerUrl = "https://login.microsoftonline.com/a8ee146e-0dcf-4435-8677-eb7f4cf3b5f5";

export const scope =  "openid";

//secret id 1296042d-6639-46a6-8488-5d4c20377623
//value RjI8Q~iodKXN2nbnH-vhqRR0-gof2k2yCjv-HcdA

//vbG8Q~2ttvUl1WoRBJSKRGNY010itw6~exyynaB7 client secret
//d6a78fa4-6a8a-457c-bbc9-efdd46a47ede client ID